// extracted by mini-css-extract-plugin
export default {"testContainer":"styles_testContainer__VMJSW","newContainer":"styles_newContainer__+AKRk","large":"styles_large__s2J1u"};